import { BehaviorSubject } from 'rxjs';

export abstract class BaseDashboardQueueService {
  public syncCompleted$: BehaviorSubject<boolean>;
  public abstract addResponse(status: boolean): void;
  public abstract addRequest(status: any): void;
}
